








































































































































import { BookingDetailsModule } from "@/store/modules/bookingDetails";
import { Component, Vue } from "vue-property-decorator";
import GiganautVue from "@/components/Shared/GiganautVue";
import BookingDateCreate from "@/components/BookingDates/BookingDateCreate.vue";
import BookingDateDto from "@/models/BookingDates/BookingDateDto";
import { VuetifyConfirmObject } from "vuetify-confirm";
import BookingGeneralDetailsEdit from '@/components/Bookings/BookingGeneralDetailsEdit.vue';

@Component({
  name: "BookingDetails",
  components: { BookingDateCreate, BookingGeneralDetailsEdit },
})
export default class extends GiganautVue {
  get dates() {
    return BookingDetailsModule.currentBooking.dates;
  }

  get currentBooking() {
    return BookingDetailsModule.currentBooking;
  }

  async deleteDate(bookingDate: BookingDateDto) {
    const options: VuetifyConfirmObject = {
      buttonTrueText: "DELETE",
      buttonFalseText: "CANCEL",
      buttonTrueColor: "primary",
      buttonFalseColor: "primary",
    };
    const result = await this.$confirm(
      "Are you sure you want to delete this date?",
      options
    );
    if (result) {
      await BookingDetailsModule.deleteBookingDate(bookingDate);
    }
  }

  // get datesSummary() {
  //     let dates = "";
  //     for (let i=0; i < BookingDetailsModule.currentBooking.dates.length; i++) {
  //         if (i !== 0) {
  //             dates += ", ";
  // 		}
  //         dates += DateTimeUtils.toShortDate(new Date(BookingDetailsModule.currentBooking.dates[i].date));
  //     }
  //     return dates;
  // }

  private headers = [{ text: "Date", value: "date" }, { text: "Actions" }];
}
